exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".displayblock[data-v-210551a2]{display:block}@media (max-width:768px){.modal[data-v-210551a2]{width:100%;max-width:100%;height:100vh;margin:0;min-height:100vh}.modal-dialog[data-v-210551a2]{margin:0!important;padding:0!important;height:100vh}.modal-body[data-v-210551a2]{height:calc(-105px + 100vh)}.modal-content[data-v-210551a2]{height:calc(100vh - 170px)!important;flex:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-210551a2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/modal-three-buttons.vue
// module id = 1290
// module chunks = 0